import React from 'react';
import { useLocation } from 'react-router-dom';
import { TopMenuButton } from '../button';
import BuglyHelper from './icons/bugly-helper.react.svg?react';

export const Helper = () => {
  const { pathname } = useLocation();
  let wxUrl = 'wxwork://message?uin=8444251803319680';
  let btnText = 'Bugly小助手';
  if (pathname.startsWith('/compliance')) {
    wxUrl = 'wxwork://message?uin=8444251012323332';
    btnText = 'Rightly小助手';
  }
  const onClick = () => window.open(wxUrl, '_self', 'noreferrer');
  return   <TopMenuButton  onClick={onClick} >
    <BuglyHelper/>
    <span>{btnText}</span>
  </TopMenuButton>;
};
